module.exports = __webpack_public_path__ + "img/circle-empty.1c2a17d2.svg";